import React from 'react';

import { MediaStateType } from './types';

export const MediaQueriesContext = React.createContext<MediaStateType>({} as MediaStateType);
